import { Loader2 } from "lucide-react";
import { ReportGroup } from "./report-group";
import { ReportListEmptyState } from "./report-list-empty-state";
import { ReportListToolbar } from "./report-list-toolbar";
import { ReportGroupData, ReportVersion } from "./types";

interface ReportListProps {
  years: number[];
  activeYear: number;
  onYearChange: (year: number) => void;
  /** 방금 업로드된 보고서가 들어간 연도 */
  newYears?: Set<number>;
  groups: ReportGroupData[];
  isLoading?: boolean;
  onOpenVersion?: (version: ReportVersion) => void;
  onVersionUpdate?: (group: ReportGroupData) => void;
  /** 빈 상태의 "DSD 보고서 업로드" 버튼 */
  onUpload?: () => void;
  renderMenu?: (version: ReportVersion) => React.ReactNode;
  typeControl?: React.ReactNode;
  sortControl?: React.ReactNode;
  /** 작성자 이름 조회 중이면 이메일 대신 스켈레톤을 보여준다. */
  isAuthorLoading?: boolean;
}

// ============================================
// ReportList
// 툴바 + 보고서 그룹 목록. 순수 표현 컴포넌트(데이터/상태는 상위 책임).
// ============================================

export const ReportList = ({
  years,
  activeYear,
  onYearChange,
  newYears,
  groups,
  isLoading,
  onOpenVersion,
  onVersionUpdate,
  onUpload,
  renderMenu,
  typeControl,
  sortControl,
  isAuthorLoading,
}: ReportListProps) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <ReportListToolbar
        years={years}
        activeYear={activeYear}
        onYearChange={onYearChange}
        newYears={newYears}
        typeControl={typeControl}
        sortControl={sortControl}
      />

      {isLoading ? (
        <div className="flex h-40 w-full items-center justify-center">
          <Loader2 className="size-6 animate-spin text-neutral-400" />
        </div>
      ) : groups.length === 0 ? (
        <ReportListEmptyState onUpload={onUpload} />
      ) : (
        <div className="flex flex-col gap-2">
          {groups.map((group) => (
            <ReportGroup
              key={group.key}
              group={group}
              onOpenVersion={onOpenVersion}
              onVersionUpdate={onVersionUpdate}
              renderMenu={renderMenu}
              isAuthorLoading={isAuthorLoading}
            />
          ))}
        </div>
      )}
    </div>
  );
};
